<template>
	<div class="about-us">
		<div class="top">
			<img src="../assets/imgs/abouttop.jpg" alt="" />
		</div>
		<div class="company-profile">
			<div class="contact-title">
				<div class="contact-title-t1">{{ $t("menuList.company") }}</div>
				<span></span>
			</div>
			<div class="company-content">
				<div><img src="../assets/imgs/company.png" alt="" /></div>
				<div>
					<p>
						{{
							isEn
								? companyMsg.companyProfile
								: companyMsg.companyCnProfile
						}}
						<!-- {{
							isEn
								? companyMsg.companyCnProfile
								: companyMsg.companyProfile
						}} -->
					</p>
				</div>
			</div>
			<div v-if="!isEn" class="company-profile-img">
				<div v-for="(item, i) in companyImgFilter" :key="i">
					<img v-lazy="`${$queryUrl}${item}`" alt="" />
				</div>
			</div>
			<div v-if="isEn" class="company-profile-img">
				<div v-for="(item, i) in companyImgFilter" :key="i">
					<img v-lazy="`${$queryUrl}${item}`" alt="" />
				</div>
			</div>
			<div class="contact-title">
				<div class="contact-title-t1">
					{{ $t("aboutUs.corporate") }}
				</div>
				<span></span>
			</div>
			<ul class="company-profile-corporate">
				<li>
					<div class="img-box">
						<img src="../assets/imgs/corporate-1.jpg" alt="" />
					</div>
					<div class="text-box">
						<div class="contact-title">
							<div class="corporate-text">{{ $t("Vision") }}</div>
							<span></span><br />
							<label>{{ $t("VisionContent") }}</label>
						</div>
					</div>
				</li>
				<li>
					<div class="text-box">
						<div class="contact-title">
							<div class="corporate-text">
								{{ $t("Mission") }}
							</div>
							<span></span><br />
							<label>{{ $t("MissionContent") }}</label>
						</div>
					</div>
					<div class="img-box">
						<img src="../assets/imgs/corporate-2.jpg" alt="" />
					</div>
				</li>
				<li>
					<div class="img-box">
						<img src="../assets/imgs/corporate-3.jpg" alt="" />
					</div>
					<div class="text-box">
						<div class="contact-title">
							<div class="corporate-text">
								{{ $t("CoreValue") }}
							</div>
							<span></span><br />
							<label>{{ $t("CoreValueContent") }}</label>
						</div>
					</div>
				</li>
			</ul>
			<div class="contact-title">
				<div class="contact-title-t1">{{ $t("corestTitle") }}</div>
				<span></span>
			</div>
			<ul class="cores">
				<li v-for="(item, index) in Cores" :key="index">
					<div class="img-box">
						<img :src="requireImg(item.icon)" alt="" />
					</div>
					<h3>{{ item.title }}</h3>
					<div class="value">{{ item.value }}</div>
				</li>
			</ul>
			<div class="contact-title">
				<div class="contact-title-t1">{{ $t("aboutUs.Business") }}</div>
				<span></span>
			</div>
			<div class="img-box-big">
				<img src="../assets/imgs/map.png" alt="" />
			</div>
			<div class="contact-title">
				<div class="contact-title-t1">{{ $t("aboutUs.honor") }}</div>
				<span></span>
			</div>
			<div class="img-box-big">
				<img src="../assets/imgs/honor.jpg" alt="" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			companyMsg: {},
			companyImg: [],
			isEn: ((this.$cookies.get("SET_LANG") === undefined ) ? "en-US" : (this.$cookies.get("SET_LANG")) ) === "en-US",
			Cores: this.$t("Cores"),
		};
	},
	created() {
		this.getcompanyMsg();
	},
	computed: {
		companyImgFilter: function() {
			return this.companyImg.filter((item) => {
				return item;
			});
		},
	},
	methods: {
		// 公司信息
		getcompanyMsg() {
			this.$axios.post(`selectCompanyInfo`).then((res) => {
				this.companyMsg = res.data.data[0];	
				// alert(this.$cookies.get("SET_LANG"));			
				// alert(this.companyMsg.companyProfile);
				// alert(this.companyMsg.companyCnProfile);
				this.companyImg.push(
					this.companyMsg.image1,
					this.companyMsg.image2,
					this.companyMsg.image3,
					this.companyMsg.image4
				);
				this.vedioUrl = this.companyMsg.video;
			});
		},
		requireImg(img) {
			return require(`../assets/imgs/${img}.png`);
		},
	},
};
</script>
<style lang="scss">
.about-us {
	.top {
		height: 300px;
		img {
			height: 100%;
			width: 100%;
		}
	}
	.company-profile {
		padding: 16px 0;
		width: 1200px;
		margin: 0 auto;
		h3 {
			font-size: 26px;
			color: #666;
			padding-bottom: 20px;
		}
		p {
			padding: 40px;
			text-indent: 2em;
			font-size: 14px;
			line-height: 24px;
			color: #666;
		}
		.contact-title {
			visibility: visible;
			animation-name: fadeInUp;
			text-align: center;
			padding: 4% 0 3%;
			.contact-title-t1 {
				font-size: 30px;
				color: #666;
			}
			.contact-title-t2 {
				font-size: 20px;
				color: #333;
			}
			span {
				display: inline-block;
				width: 33px;
				height: 3px;
				background: #ff9801;
				margin: 10px 0;
			}
		}
		.company-content {
			display: flex;
			align-items: center;
			div {
				flex: 1;
				img {
					width: 100%;
				}
			}
			p {
				word-break: break-word;
				text-align: left;
			}
		}
		.company-profile-img {
			display: flex;
			padding: 14px 0;
			line-height: 400px;
			> div {
				flex: 1;
				border: 1px solid #ccc;
				margin: 0 10px;
				img {
					width: 100%;
				}
			}
		}
		.company-profile-corporate {
			display: flex;
			// margin-bottom: 60px;
			li {
				cursor: pointer;
				&:hover {
					.img-box {
						img {
							transform: scale(1.1);
						}
					}
					.text-box {
						background: #071c83;
					}
				}
			}
			li:first-child {
				flex: 3;
			}
			li:not(:first-child) {
				flex: 2;
			}
			.img-box {
				overflow: hidden;
				height: 236px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.text-box {
				transition: 500ms;
				height: 236px;
				background: #f8f8f8;
				width: 100%;
				color: #fff;
				display: table;
				> div {
					display: table-cell;
					vertical-align: middle;
					padding: 10px;
					color: #f8f8f8;
				}
				.corporate-text {
					text-align: center;
					font-size: 24px;
				}
			}
		}
		.img-box-big {
			overflow: hidden;
			img {
				width: 100%;
				// &:hover {
				//   transform: scale(1.1);
				// }
			}
			&:last-child {
				margin-bottom: 60px;
			}
		}
	}
	.cores {
		display: flex;
		li {
			width: 25%;
			padding: 24px 24px;
			border: 1px solid #ccc;
			h3 {
				text-align: center;
			}
			.img-box {
				height: 48px;
				text-align: center;
				margin-bottom: 18px;
			}
			.value {
				line-height: 30px;
				text-indent: 2em;
			}
		}
		li + li {
			margin-left: 24px;
		}
	}
}
</style>
